import { Router as ReactRouter, Route, Switch, Redirect } from 'react-router-dom';

import { DialogManager } from 'components/dialog';

import { history } from './history';
import * as routes from './routes';
import { privatePaths, publicPaths } from './paths';
import PublicRoutes from './PublicRoutes';
import PrivateRoutes from './PrivateRoutes';

const Router = () => {
  return (
    <ReactRouter history={history}>
      <Switch>
        <Route path={publicPaths}>
          <PublicRoutes />
        </Route>
        <Route path={privatePaths}>
          <PrivateRoutes />
        </Route>
        <Redirect from="*" to={routes.home} />
      </Switch>

      <DialogManager />
    </ReactRouter>
  );
};

export default Router;
